import styled from 'styled-components';
import ImgMain from '../../../../../assets/img/Part01.png';
import ImgMission from '../../../../../assets/img/img-mission.png';

const ContainerSectionOneImage = styled.div`
  background-image: url(${ImgMain});
  width: 100%;
  height: 1200px;
  background-repeat: no-repeat;
  background-size: contain;
  background-size: cover;
  background-position: center;
`;

const ContainerSectionMissionImage = styled.div`
  background-image: url(${ImgMain});
  width: 100%;
  height: 900px;
  background-repeat: no-repeat;
  background-size: contain;
  background-size: cover;
  background-position: center;
`;

export { ContainerSectionOneImage, ContainerSectionMissionImage };
